import { toLower, trim } from 'lodash';

const normalizeEmail = (email) => toLower(trim(email));

export default normalizeEmail;
